module.exports = __webpack_public_path__ + "img/series_btn.png.c8739e16.webp";